// extracted by mini-css-extract-plugin
export default {"legendIndicator":"xka-z","legendNew":"yka-z"};